/**
 * @generated SignedSource<<c774cda1a54f5927ce597a37431a21c5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type BuildState = "deleted" | "finished" | "queued" | "running" | "unknown";
import { FragmentRefs } from "relay-runtime";
export type PipelineLastRunJobFragment$data = {
  readonly artifacts: {
    readonly count: number | null | undefined;
  } | null | undefined;
  readonly buildType: {
    readonly name: string | null | undefined;
  } | null | undefined;
  readonly parallelized: boolean | null | undefined;
  readonly rawId: number | null | undefined;
  readonly runningInfo: {
    readonly leftSeconds: number | null | undefined;
    readonly percentageComplete: number | null | undefined;
  } | null | undefined;
  readonly snapshotDependencies: {
    readonly build: ReadonlyArray<{
      readonly runningInfo: {
        readonly leftSeconds: number | null | undefined;
        readonly percentageComplete: number | null | undefined;
      } | null | undefined;
    }> | null | undefined;
  } | null | undefined;
  readonly state: BuildState | null | undefined;
  readonly status: string | null | undefined;
  readonly statusText: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"useBuildStatusIconFragment" | "useRunningBuildUpdaterRelayFragment">;
  readonly " $fragmentType": "PipelineLastRunJobFragment";
};
export type PipelineLastRunJobFragment$key = {
  readonly " $data"?: PipelineLastRunJobFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"PipelineLastRunJobFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "concreteType": "ProgressInfo",
  "kind": "LinkedField",
  "name": "runningInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "percentageComplete",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "leftSeconds",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PipelineLastRunJobFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rawId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BuildTypeRest",
      "kind": "LinkedField",
      "name": "buildType",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "parallelized",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "state",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "statusText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Files",
      "kind": "LinkedField",
      "name": "artifacts",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Builds",
      "kind": "LinkedField",
      "name": "snapshotDependencies",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Build",
          "kind": "LinkedField",
          "name": "build",
          "plural": true,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useBuildStatusIconFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useRunningBuildUpdaterRelayFragment"
    }
  ],
  "type": "Build",
  "abstractKey": null
};
})();

(node as any).hash = "3374adf933457c91c1420f3bfa4c3c5a";

export default node;
